import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { withNamespaces } from "react-i18next";
import posed, { PoseGroup } from "react-pose";
import { Button, InputGroup } from "@blueprintjs/core";

const Modal = posed.div({
  enter: {
    y: 0,
    opacity: 1,
    delay: 300
  },
  exit: {
    y: 50,
    opacity: 0,
    transition: { duration: 150 }
  }
});

const Shade = posed.div({
  enter: { opacity: 1 },
  exit: { opacity: 0 }
});

class RequestWishlistEmail extends PureComponent {
  static propTypes = {
    isVisible: PropTypes.bool.isRequired,
    onHide: PropTypes.func,
    email: PropTypes.string,
    onUpdateEmail: PropTypes.func,
    onSubmit: PropTypes.func,
  };

  static defaultProps = {
    isVisible: false,
    onHide: () => {},
    email: null,
    onUpdateEmail: () => {},
    onSubmit: () => {}
  };

  render() {
    return (
      <div className="wishlist-request-email-container">
        <PoseGroup>
          {this.props.isVisible && [
            <Shade key="shade" className="shade" />,
            <Modal key="modal" className="modal">
              <div className="content-wrap">
                <div className="title">
                  <i className="icon-envelope" />
                  {this.props.t("wishlist:send_to_email")}
                </div>
                <div className="form">
                  <InputGroup
                    large={true}
                    leftIcon="envelope"
                    value={this.props.email}
                    onChange={event => {
                      this.props.onUpdateEmail(event.target.value);
                    }}
                    placeholder={this.props.t("wishlist:email_placeholder")}
                  />
                </div>
                <div className="action">
                  <Button
                    large
                    text={this.props.t("wishlist:button_cancel")}
                    style={{ minWidth: "125px" }}
                    onClick={this.props.onHide}
                  />
                  <Button
                    large
                    intent="danger"
                    text={this.props.t("wishlist:button_send")}
                    style={{ minWidth: "125px" }}
                    onClick={this.props.onSubmit}
                  />
                </div>
              </div>
            </Modal>
          ]}
        </PoseGroup>
      </div>
    );
  }
}

export default withNamespaces(["wishlist", "common"], { wait: true })(
  RequestWishlistEmail
);
